var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFujifilmDarkIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1029px",
    height: "172px",
    viewBox: "0 0 1029 172",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "fujifilm_icon") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    colorInterpolationFilters: "auto",
    id: "filter-1"
  }, /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceGraphic",
    type: "matrix",
    values: "0 0 0 0 1.000000 0 0 0 0 1.000000 0 0 0 0 1.000000 0 0 0 1.000000 0"
  })), /*#__PURE__*/React.createElement("filter", {
    colorInterpolationFilters: "auto",
    id: "filter-2"
  }, /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceGraphic",
    type: "matrix",
    values: "0 0 0 0 1.000000 0 0 0 0 1.000000 0 0 0 0 1.000000 0 0 0 1.000000 0"
  })), /*#__PURE__*/React.createElement("filter", {
    colorInterpolationFilters: "auto",
    id: "filter-3"
  }, /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceGraphic",
    type: "matrix",
    values: "0 0 0 0 1.000000 0 0 0 0 1.000000 0 0 0 0 1.000000 0 0 0 1.000000 0"
  })), /*#__PURE__*/React.createElement("filter", {
    colorInterpolationFilters: "auto",
    id: "filter-4"
  }, /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceGraphic",
    type: "matrix",
    values: "0 0 0 0 1.000000 0 0 0 0 1.000000 0 0 0 0 1.000000 0 0 0 1.000000 0"
  })), /*#__PURE__*/React.createElement("filter", {
    colorInterpolationFilters: "auto",
    id: "filter-5"
  }, /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceGraphic",
    type: "matrix",
    values: "0 0 0 0 1.000000 0 0 0 0 1.000000 0 0 0 0 1.000000 0 0 0 1.000000 0"
  })), /*#__PURE__*/React.createElement("filter", {
    colorInterpolationFilters: "auto",
    id: "filter-6"
  }, /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceGraphic",
    type: "matrix",
    values: "0 0 0 0 1.000000 0 0 0 0 1.000000 0 0 0 0 1.000000 0 0 0 1.000000 0"
  })), /*#__PURE__*/React.createElement("filter", {
    colorInterpolationFilters: "auto",
    id: "filter-7"
  }, /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceGraphic",
    type: "matrix",
    values: "0 0 0 0 1.000000 0 0 0 0 1.000000 0 0 0 0 1.000000 0 0 0 1.000000 0"
  })), /*#__PURE__*/React.createElement("filter", {
    colorInterpolationFilters: "auto",
    id: "filter-8"
  }, /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceGraphic",
    type: "matrix",
    values: "0 0 0 0 1.000000 0 0 0 0 1.000000 0 0 0 0 1.000000 0 0 0 1.000000 0"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Quench-Vent-Calculator",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "fujifilm_icon"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter-1)",
    id: "g24728"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(791.203448, 82.796719) scale(-1, 1) rotate(-180.000000) translate(-791.203448, -82.796719) translate(741.392772, 0.020894)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M42.3928369,165.55165 L42.3928369,31.5314872 C42.3928369,22.8206303 46.6938224,18.3472423 55.4591222,17.9026257 C55.5680079,17.8935519 99.6213518,17.8935519 99.6213518,17.8935519 L99.6213518,2.85824992 C99.6213518,1.1795952 98.7139709,0 96.8447662,0 L25.3522231,0 C3.26657133,0 0,12.1589044 0,23.2017303 L0,156.441545 C0,162.729695 2.39548564,165.705905 9.82693543,165.542576 L42.3928369,165.55165",
    id: "path24730",
    fill: "#000000",
    fillRule: "nonzero"
  }))), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter-2)",
    id: "g24732"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(680.184460, 82.796719) scale(-1, 1) rotate(-180.000000) translate(-680.184460, -82.796719) translate(658.965357, 0.020894)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M42.4291321,165.55165 L42.4382059,8.72900451 C42.4382059,1.75124519 39.4801441,0 33.5458728,0 L0,0 L0,156.895236 C0,162.067307 1.97809042,165.542576 9.50027829,165.542576 L42.4291321,165.55165",
    id: "path24734",
    fill: "#000000",
    fillRule: "nonzero"
  }))), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter-3)",
    id: "g24736"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(55.949108, 82.782607) scale(-1, 1) rotate(-180.000000) translate(-55.949108, -82.782607) "
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0,142.726436 C0,155.348105 0.0272214278,165.565214 20.7608756,165.565214 L111.898216,165.565214 L111.898216,149.631605 C111.898216,148.497379 111.362861,147.472039 109.774944,147.472039 L55.1596865,147.490186 C47.8189748,147.490186 44.1259344,143.969548 44.1259344,136.56532 L44.1259344,94.5263617 L108.386652,94.5263617 L108.395725,77.8305527 C108.395725,76.3515218 107.470197,75.5711742 106.018387,75.5711742 L44.1259344,75.5711742 L44.1259344,8.8696023 C43.9898273,2.43627153 40.7776988,-0.122542679 33.7182752,0.00449065103 L0,0.00449065103 L0,142.726436",
    id: "path24738",
    fill: "#000000",
    fillRule: "nonzero"
  }))), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter-4)",
    id: "g24740"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(206.132452, 85.618806) scale(-1, 1) rotate(-180.000000) translate(-206.132452, -85.618806) translate(135.334056, 0.004572)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M42.383763,171.228468 L42.383763,45.039003 C42.383763,34.2048747 43.9172368,26.6100964 51.521089,22.2183727 C61.7109768,16.3203967 78.969362,16.2296586 89.3588736,22.0550441 C96.4636662,26.0202987 99.1767352,32.3901128 99.1767352,45.0027077 L99.1767352,162.817047 C99.1767352,168.116152 101.200195,171.228468 108.604423,171.228468 L141.58772,171.228468 L141.596793,48.7683386 C141.596793,20.3219465 123.685094,8.65302783 107.851297,4.32482081 C86.7819117,-1.41890045 54.7785865,-1.50963854 34.8978704,4.46092795 C11.1426378,11.6110896 0.0453690463,25.675494 0.0181476185,48.7592647 L0,162.726309 C0,168.225037 1.97809042,171.228468 8.30253547,171.228468 L42.383763,171.228468",
    id: "path24742",
    fill: "#000000",
    fillRule: "nonzero"
  }))), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter-5)",
    id: "g24744"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(945.166070, 82.796736) scale(-1, 1) rotate(-180.000000) translate(-945.166070, -82.796736) translate(861.396663, 0.020911)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M118.494875,165.542576 C110.128823,165.542576 105.355999,161.640838 103.468647,154.173093 L76.4559168,40.0154988 L75.7209383,40.0336464 L47.8189748,165.542576 L9.67268067,165.542576 C2.31382136,165.542576 0,161.758798 0,155.915264 L0,0 L16.1150852,0 C18.7101947,0 19.7809042,1.28848091 19.7809042,3.92895941 L19.7809042,134.655329 L22.3306446,134.655329 L56.8201936,0 L79.4049048,0 C87.9161379,0 91.0828973,3.49341656 93.1789473,11.9048377 L124.138784,134.655329 L126.643156,134.655329 L126.634082,0 L156.768203,0.0453690463 C164.163357,0.0453690463 167.538814,2.88547134 167.538814,10.1535926 L167.538814,165.55165 L118.494875,165.542576",
    id: "path24746",
    fill: "#000000",
    fillRule: "nonzero"
  }))), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter-6)",
    id: "g24748"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(457.273712, 127.781009) scale(-1, 1) rotate(-180.000000) translate(-457.273712, -127.781009) translate(436.063683, 89.988594)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M42.4109845,75.5848311 L0,75.5848311 L0,0 L33.536799,0 C39.4438488,0 42.4200583,1.73309757 42.4200583,8.72900451 C42.4200583,8.72900451 42.4109845,41.0589869 42.4109845,75.5848311",
    id: "path24750",
    fill: "#000000",
    fillRule: "nonzero"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "g24752",
    transform: "translate(457.270070, 44.500681) scale(-1, 1) rotate(-180.000000) translate(-457.270070, -44.500681) translate(436.069115, 0.034479)",
    fill: "#ED1A3A",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M39.9338345,31.2774205 C41.4219393,32.4842371 42.293025,33.3916181 42.4019107,35.9867275 L42.4019107,88.9324045 L9.47305687,88.9324045 C2.0597547,88.9324045 0,85.3119546 0,80.158031 L0,0 L39.9338345,31.2774205",
    id: "path24754"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter-7)",
    id: "g24756"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(345.915313, 85.612330) scale(-1, 1) rotate(-180.000000) translate(-345.915313, -85.612330) translate(294.267190, 0.000939)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M36.3406061,18.7464899 C54.7604389,21.3506732 60.8852601,32.2936872 60.8852601,48.42692 L60.8852601,162.212488 C60.8852601,169.017845 64.5692267,171.222781 69.3239027,171.222781 L103.296245,171.222781 L103.296245,63.6346243 C103.296245,37.1753965 97.7249257,23.8096755 82.0544571,12.5309306 C73.8971026,6.67832361 59.6330744,0 28.7276801,0 C11.0337521,0 3.16675943,0.998119018 2.10512375,1.24311187 C0.60794522,1.58791662 0,2.50437136 0,3.80192608 L0,17.6939281 C7.26812122,17.4852304 23.9094874,16.9770971 36.3406061,18.7464899",
    id: "path24758",
    fill: "#000000",
    fillRule: "nonzero"
  }))), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter-8)",
    id: "g24760"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(563.047980, 82.782955) scale(-1, 1) rotate(-180.000000) translate(-563.047980, -82.782955) translate(492.213288, 0.004570)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M50.5138961,165.55677 C29.7983896,165.55677 29.7893158,155.339661 29.7893158,142.717992 L29.7893158,100.062015 C29.7893158,99.1818552 29.4082158,98.8279767 29.0089682,98.4378029 L0,75.5808774 L29.7893158,75.5808774 L29.7893158,0.00512004829 L63.4894434,0.00512004829 C70.548867,-0.130987091 73.7609955,2.43690093 73.878955,8.86115788 L73.878955,75.5627297 L135.771408,75.5627297 C137.223217,75.5627297 138.15782,76.3521511 138.15782,77.8221082 L138.15782,94.5269911 L73.878955,94.5269911 L73.878955,136.565949 C73.878955,143.961104 77.5810692,147.490816 84.912707,147.490816 L139.546113,147.472668 C141.115882,147.472668 141.669384,148.488935 141.669384,149.623161 L141.669384,165.55677 L50.5138961,165.55677",
    id: "path24762",
    fill: "#000000",
    fillRule: "nonzero"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFujifilmDarkIcon);
export default __webpack_public_path__ + "static/media/fujifilm_dark_icon.22dd56d65e9c28da3d551ce15ac2c45b.svg";
export { ForwardRef as ReactComponent };